export default "__VITE_ASSET__CE9qvTvE__"